import React from "react";
import TextField from "@mui/material/TextField";

const InputUI = ({
  name,
  label,
  type,
  value,
  setValue,
  variant,
  fullWidth,
  required,
  cssStyles,
  disabled,
  register,
  inputProps,
  registerOptions,
  multiline,
  minRows,
  onKeyDown,
  ...rest
}) => {
  return (
    <TextField
      name={name}
      label={label}
      type={type}
      autoComplete="off"
      value={value}
      onChange={(e) => setValue && setValue(e.target.value)}
      variant={variant}
      fullWidth={fullWidth}
      required={required}
      style={cssStyles}
      disabled={disabled}
      inputProps={inputProps}
      multiline={multiline}
      minRows={minRows}
      onKeyDown={onKeyDown}
      {...rest}
      {...(register ? register(name, registerOptions) : {})}
    />
  );
};

export default InputUI;
